import React from 'react';
import {
  WhyAuditSection,
  WhyAuditContent,
  WhyAuditList,
  WhyAuditItem,
} from './Why.styles';

const Why = () => {
  return (
    <WhyAuditSection>
      <WhyAuditContent>
        <p className="eyebrowHeader">Why Review Your Safety Program?</p>

        <h2>Small Gaps Are Easier to Address When You Can See Them</h2>

        <p>
          Safety programs naturally evolve as workplaces grow, roles change, new
          employees join, and procedures are updated. An audit provides an
          opportunity to review the system as a whole rather than waiting for a
          problem to reveal where something was missing.
        </p>

        <p>
          The goal is not simply to produce a list of findings. It is to give
          your organization useful information that can support better safety
          decisions moving forward.
        </p>
      </WhyAuditContent>

      <WhyAuditList>
        <WhyAuditItem>
          <span>01</span>
          <p>Identify areas that may have been overlooked</p>
        </WhyAuditItem>

        <WhyAuditItem>
          <span>02</span>
          <p>Review whether current processes still fit the workplace</p>
        </WhyAuditItem>

        <WhyAuditItem>
          <span>03</span>
          <p>Support more consistent safety practices</p>
        </WhyAuditItem>

        <WhyAuditItem>
          <span>04</span>
          <p>Create clearer priorities for future improvements</p>
        </WhyAuditItem>
      </WhyAuditList>
    </WhyAuditSection>
  );
};

export default Why;
